import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  { key: 'name', header: 'Division', type: 'text', width: 45 },
  {
    key: 'percentage',
    header: '% Of Finished Goods Mapped',
    type: 'text',
    width: 40,
  },
  { key: 'fGLocations', header: 'FG Locations Mapped', type: 'text' },
  { key: 'l1Locations', header: 'L1 Locations Mapped', type: 'text' },
  { key: 'l2Locations', header: 'L2 Locations Mapped', type: 'text' },
  { key: 'l3PlusLocations', header: 'L3+ Locations Mapped', type: 'text' },
];
